// TODO(@fabric-ui) - rule not in this repo
// /* eslint-disable custom-rules/no-import-meta-env */

import projectEnvVariables, { ProjectEnvVariablesType } from './env';

const isPlaceholder = (value: any) => typeof value === 'string' && value.startsWith('${') && value.endsWith('}');

// TODO(@fabric-ui) used below
// type ImportMeta = key as keyof ImportMetaEnv
type ImportMeta = string;

// Returning the variable value from runtime or obtained as a result of the build
const getProjectEnvVariables = (): { envVariables: ProjectEnvVariablesType } => {
  const envVariables = {} as ProjectEnvVariablesType;
  Object.keys((import.meta as any).env).forEach(key => {
    if (Object.prototype.hasOwnProperty.call((import.meta as any).env, key)) {
      const value = projectEnvVariables[key as keyof ProjectEnvVariablesType] || (import.meta as any).env[key as keyof ImportMeta];
      envVariables[key as keyof ProjectEnvVariablesType] = isPlaceholder(value) ? (import.meta as any).env[key as keyof ImportMeta] : value;
    }
  });

  return { envVariables };
};

export const { envVariables } = getProjectEnvVariables();
